<template>
  <div class="hot">
    <div class="h-top">
      <div class="title">热门搜索</div>
      <!--  <img class="hot-icon" src="" alt=""> -->
      <div class="hot-icon">HOT</div>
    </div>
    <div class="hot-list">
      <div
        class="hot-item"
        v-for="(item, index) in list"
        @click="bindClick(item)"
        :key="index"
        >{{ item }}</div
      >
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  inject: ['getHotData'],
  data() {
    return {}
  },
  computed: {
    list() {
      return this.getHotData() || []
    }
  },
  created() {},
  methods: {
    bindClick(item) {
      this.$emit('search', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.hot {
  color: rgba(0, 0, 0, 0.8);

  .h-top {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .title {
      font-weight: bold;
      font-size: 16px;
      line-height: 20px;
      margin-right: 8px;
    }

    .hot-icon {
      text-align: center;
      width: 32px;
      height: 15px;
      border-radius: 8px 8px 8px 0px;
      background: linear-gradient(220deg, #fc4444 0%, #ffa154 100%);
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 9px;
      color: #ffffff;
      line-height: 15px;
      animation: jumpAnimate 1s;
      animation-iteration-count: infinite;
      transform-origin: center bottom;
      animation-fill-mode: both;
    }
  }

  .hot-list {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    max-height: 80px;
    overflow: hidden;
    .hot-item {
      max-width: 150px;
      padding: 0px 12px;
      box-sizing: border-box;
      height: 28px;
      line-height: 28px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      background: #f1f1f3;
      border-radius: 14px;
      margin-right: 10px;
      margin-bottom: 12px;
    }
  }
}

@keyframes jumpAnimate {
  0%,
  20%,
  53%,
  100% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -4px, 0) scaleY(1.1);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -2px, 0) scaleY(1.05);
  }

  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  90% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, -1px, 0) scaleY(1.02);
  }
}
</style>
